// src/routes/routeConfigs.ts (집계 파일)
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { RouteConfig } from './types';
import { studentRoutes } from './studentRoutes';
import { academyRoutes } from './academyRoutes';
import { adminRoutes } from './adminRoutes';

// 슬러그 기반 학원 인덱스 리다이렉트 컴포넌트
const AcademyIndexRedirectSlug: React.FC = () => {
  const { slug } = useParams();
  const hasToken = !!localStorage.getItem('academy_token');
  const dest = hasToken ? `/${slug}/academy/home` : `/${slug}/academy/login`;
  return <Navigate to={dest} replace />;
};

// 학원 라우트를 슬러그 버전으로 복제
const academyRoutesWithSlug: RouteConfig[] = academyRoutes.map((rc) => {
  const slugPath = rc.path.replace(/^\/academy\b/, '/:slug/academy');
  // 인덱스 경로는 슬러그 보존 리다이렉트 컴포넌트로 대체
  const element = rc.path === '/academy' ? <AcademyIndexRedirectSlug /> : rc.element;
  return { ...rc, path: slugPath, element };
});

// 학생 라우트를 슬러그 버전으로 복제
const studentRoutesWithSlug: RouteConfig[] = studentRoutes
  .filter((rc) => {
    // 이미 별도로 추가된 공개/인덱스 경로는 제외
    const p = rc.path || '';
    return !['/', '/login', '/sign_up', '/find_id', '/report/:token'].includes(p);
  })
  .map((rc) => {
    const p = rc.path || '';
    const normalized = p.startsWith('/') ? p.slice(1) : p;
    const slugPath = `/:slug/${normalized}`;
    return { ...rc, path: slugPath };
  });

export const routeConfigs: RouteConfig[] = [
  ...studentRoutes,
  ...studentRoutesWithSlug,
  ...academyRoutes,
  // 슬러그 학원 인덱스(트레일링 슬래시 포함) 별도 처리
  {
    path: '/:slug/academy',
    name: '학원 인덱스(slug)',
    element: <AcademyIndexRedirectSlug />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  {
    path: '/:slug/academy/',
    name: '학원 인덱스(slug, trailing)',
    element: <AcademyIndexRedirectSlug />,
    background: 'solid',
    containerProps: { size: 'xl' },
  },
  ...academyRoutesWithSlug,
  ...adminRoutes,
];
 
